<template>
  <view class="cart-store-list">
    <view v-if="cartStoreList.length > 0">
      <!--  购物车列表  -->
      <view class="cart-store-item" v-for="(cItem, cIdx) in cartStoreList" :key="cIdx">
        <view class="cart-checkbox-group">
          <u-checkbox
            shape="circle"
            :active-color="checkboxActiveColor"
            v-model="cItem[0].storeAllCheck"
            @change="check('store', cIdx)"
          ></u-checkbox>
          <view class="store-info-wrap">
            <u-cell-group>
              <u-cell-item arrow :border="false" :title="cItem[0].storeName" />
            </u-cell-group>
          </view>
        </view>
        <view class="cart-checkbox-group" v-for="(gItem, gIdx) in cItem" :key="gIdx">
          <u-checkbox
            shape="circle"
            :active-color="checkboxActiveColor"
            v-model="gItem.checked"
            :disabled="cartEdit === false && gItem.goodDetail.stock === 0"
            @change="check('item', cIdx, gIdx)"
          ></u-checkbox>
          <view class="goods-card-wrap">
            <goods-card
              :tag="gItem.goodDetail.goods.transport === 2 ? '自提' : null"
              :price="gItem.price"
              :desc="gItem.goodDetail.nameSku"
              :title="gItem.goodDetail.goods.nameSpu"
              :thumb="imgUrl + gItem.goodDetail.iconSku"
            >
              <u-tag
                type="error"
                slot="tags"
                v-if="gItem.goodDetail.stock === 0"
                text="该商品库存为0,请重新选择其他商品."
              >
              </u-tag>
              <u-number-box
                slot="num"
                v-model="gItem.numBuy"
                :disabled="gItem.goodDetail.stock === 0"
                :min="gItem.goodDetail.stock === 0 ? 0 : 1"
                :max="gItem.goodDetail.stock"
                integer
                @change="onNumBuyChange($event, cIdx, gIdx)"
              />
            </goods-card>
          </view>
        </view>
      </view>
      <view class="cart-oth">
        <u-button size="mini" @click="handleEditCart">编辑</u-button>
      </view>
      <!--  去结算  -->
      <submit-bar
        v-if="cartEdit === false"
        :price="total"
        :disabled="totalNumBuy === 0"
        button-text="去结算"
        @submit="handleCreateOrder"
      >
        <u-checkbox shape="circle" :active-color="checkboxActiveColor" v-model="allChecked" @change="check('all')">
          {{ allChecked ? '不全选' : '全选' }}
        </u-checkbox>
      </submit-bar>
      <!--  删除购车商品  -->
      <submit-bar
        v-if="cartEdit === true"
        price-class="custom-submit-bar-price"
        bar-class="custom-bar-class"
        :disabled="totalNumBuy === 0"
        button-text="删除"
        currency=" "
        :decimal-length="0"
        @submit="delCart"
      >
        <u-checkbox shape="circle" :active-color="checkboxActiveColor" v-model="allChecked" @change="check('all')">
          {{ allChecked ? '不全选' : '全选' }}
        </u-checkbox>
      </submit-bar>
    </view>
  </view>
</template>

<script>
import { Setting, Utils } from '@';
import flattenDeep from 'lodash.flattendeep';
import cloneDeep from 'lodash.clonedeep';
import { queryCartList, delCartBunch, updateCartBunch } from '../../mall/api';
import GoodsCard from '../goods-card/GoodsCard';
import SubmitBar from '../submit-bar/SubmitBar';

export default {
  name: 'CartList',
  data() {
    return {
      imgUrl: Setting.getImgPath(),
      checkboxActiveColor: '#f33',
      cartStoreList: [],
      totalPayAmount: 0,
      disabledSubmit: true,
      total: 0, // 总价格
      totalNumBuy: 0, // 总购买数量
      allChecked: false, // 全选状态  true|false
      cartEdit: false, // 购物车编辑模式
      isFetchCartList: false, // 是否已经请求购车车列表接口
    };
  },
  components: {
    GoodsCard,
    SubmitBar,
  },
  mounted(query) {
    this.getCartList();
  },
  methods: {
    // 获取购物车列表
    async getCartList() {
      this.cartStoreList = await queryCartList(null);
      console.log('%c [this.cartStoreList]: ', 'color:#1989fa;', this.cartStoreList);
      this.isFetchCartList = true;
    },
    // 修改购买数量
    async onNumBuyChange(e, cidx, gidx) {
      // console.log('%c [修改数量]: ', 'color:#1989fa;', e.currentTarget.dataset);
      const cartStoreListCp = cloneDeep(this.cartStoreList);
      // const { cidx, gidx } = e.currentTarget.dataset;
      // console.log('%c [cIdx]: ', 'color:#1989fa;', cidx);
      // console.log('%c [gIdx]: ', 'color:#1989fa;', gidx);
      // console.log('%c [cartStoreListCp[cIdx]]: ', 'color:#1989fa;', cartStoreListCp[cidx]);
      // console.log('%c []: ', 'color:#1989fa;');
      try {
        const params = {
          form: [
            {
              gid: cartStoreListCp[cidx][gidx].gid,
              numBuy: e.value,
            },
          ],
        };
        await updateCartBunch(params);
        cartStoreListCp[cidx][gidx].numBuy = e.value;
        this.cartStoreList = cartStoreListCp;
        await this.calcTotal();
      } catch (e) {
        console.log('err', e);
        throw e;
      }
    },
    // 选中状态处理
    check(type, cartListIndex, index) {
      // console.log(' 选中状态处理 --> ', type, cartListIndex, index);
      if (type === 'store') {
        // console.log('%c [ this.cartStoreList ]: ', 'color:#1989fa;', this.cartStoreList);
        const _cartListByStore = cloneDeep(this.cartStoreList);
        const curStoreAllCheck = _cartListByStore[cartListIndex].every(item => item.checked === true);
        _cartListByStore[cartListIndex].forEach(item => {
          item.checked = !curStoreAllCheck;
        });
        this.cartStoreList = _cartListByStore;
        // 判断本店铺的商品是否全选
        if (this.cartStoreList[cartListIndex].every(item => item.checked === true)) {
          this.cartStoreList[cartListIndex][0].storeAllCheck = true;
        } else {
          this.cartStoreList[cartListIndex][0].storeAllCheck = false;
        }
      } else if (type === 'item') {
        const _cartListByStore = cloneDeep(this.cartStoreList);
        _cartListByStore[cartListIndex][index].checked = !_cartListByStore[cartListIndex][index].checked;
        this.cartStoreList = _cartListByStore;
        // console.log(' --> ', this.cartStoreList);
        // 判断本店铺的商品是否全选
        if (this.cartStoreList[cartListIndex].every(item => item.checked === true)) {
          this.cartStoreList[cartListIndex][0].storeAllCheck = true;
        } else {
          this.cartStoreList[cartListIndex][0].storeAllCheck = false;
        }
      } else {
        // console.log(' this.allChecked 000 --> ', this.allChecked);
        // const checked = !this.allChecked;
        // console.log(' checked --> ', !this.allChecked);
        const list = cloneDeep(this.cartStoreList);
        list.forEach(item => {
          item.forEach(cartItem => {
            cartItem.checked = !this.allChecked;
          });
        });
        this.allChecked = !this.allChecked;
        // console.log(' this.allChecked 111 --> ', this.allChecked);
        // console.log(' list --> ', list);
        this.cartStoreList = list;
        // 判断本店铺的商品是否全选
        this.cartStoreList.forEach((_, cartListIndex) => {
          if (this.cartStoreList[cartListIndex].every(item => item.checked === true)) {
            this.cartStoreList[cartListIndex][0].storeAllCheck = true;
          } else {
            this.cartStoreList[cartListIndex][0].storeAllCheck = false;
          }
        });
      }
      this.calcTotal(type);
    },
    // 计算总价和总数量
    calcTotal() {
      let list = this.cartStoreList;
      if (list.length === 0) {
        this.empty = true;
        return;
      }
      let total = 0; // 总价格
      let totalNumBuy = 0; // 总购买数量
      let checked = true;
      list.forEach(item => {
        item.forEach(cartItem => {
          if (cartItem.checked === true) {
            // console.log(' 计算总价 --> ', item);
            total += cartItem.price * cartItem.numBuy;
            totalNumBuy += cartItem.numBuy;
          } else if (checked === true) {
            checked = false;
          }
        });
      });
      this.allChecked = checked;
      this.total = Number(total.toFixed(2));
      this.totalNumBuy = totalNumBuy;
    },
    // 去结算
    handleCreateOrder() {
      const newCartList = flattenDeep(this.cartStoreList);
      const selectedCartList = [];
      newCartList.forEach(cartItem => {
        if (cartItem.checked === true && cartItem.goodDetail.stock > 0) {
          selectedCartList.push(cartItem);
        }
      });
      const orderForm = selectedCartList.map(cartItem => {
        const {
          gid,
          numBuy,
          acc,
          goodDetail: { goods },
        } = cartItem;
        const goodsTransport = Utils.parseTransport(goods.transport);
        return {
          gid,
          acc,
          transport: goodsTransport.indexOf(1) > -1 ? 1 : goodsTransport[0],
          address: '',
          note: '',
          numBuy,
          payMethodPick: 0, // 支付方式 0: 现金支付; >0: 混合支付,由商品支付方式决定
        };
      });
      // const createOrderUrl = `/packageMall/order/createOrder?orderForm=${JSON.stringify(orderForm)}`;
      // uni.navigateTo({
      //   url: createOrderUrl,
      // });
      this.$emit('createOrder', orderForm);
    },
    // 购物车编辑模式
    handleEditCart() {
      this.cartEdit = !this.cartEdit;
    },
    // 删除购物车商品
    async onDelCartBunch(accArr = null) {
      let form = [];
      console.log('%c [删除购物车商品]: ', 'color:#f33;', this.cartStoreList, accArr);
      if (!accArr) {
        flattenDeep(this.cartStoreList).forEach(cartItem => {
          if (cartItem.checked === true) {
            form.push(cartItem.acc);
          }
        });
      } else {
        form = accArr;
      }
      await delCartBunch({ form });
      await this.getCartList();
    },
    // 删除购物车商品二次确认弹窗
    async delCart() {
      const _this = this;
      if (this.totalNumBuy === 0) return;
      uni.showModal({
        content: '确定删除购物车商品？',
        success: async e => {
          if (e.confirm) {
            await _this.onDelCartBunch();
            this.totalNumBuy = 0;
            this.cartEdit = false;
            uni.showToast({
              title: '删除商品成功',
            });
          }
        },
      });
    },
    // 跳转页面
    navigateToPage(url) {
      console.log('跳转页面 -->', url);
      uni.navigateTo({
        url,
      });
    },
  },
};
</script>

<style lang="scss">
.cart-store-list {
  background-color: #fafafa;
  min-height: 100vh;
  padding-bottom: 50px;

  .custom-cart-class {
    background-color: #fff !important;
  }
  .cart-store-item {
    margin-bottom: 10px;
  }
  .cart-checkbox-group {
    width: 100vw;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-left: 20rpx;
    background-color: #fff;
    border-bottom: 1px solid #f2f3f5;
    .store-info-wrap {
      padding-left: 20rpx;
      flex: 1;
      background-color: #fff;
    }
    .goods-card-wrap {
      width: 100%;
      background-color: #fff;
    }
  }

  .del-cart-bar {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 0 16px;
    -webkit-user-select: none;
    user-select: none;
    z-index: 100;
    background-color: #fff;
    height: 50px;
    .custom-del-btn-class {
      width: 110px;
      height: 40px;
    }
  }
  .custom-submit-bar-price {
    //background-color: #1bd1a5;
  }
  .custom-bar-class {
    //background-color: #f8d402;
    justify-content: space-between;
  }
  .cart-oth {
    padding-left: 30rpx;
  }
}
</style>
